// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Hierarchy2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Hierarchy2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.625 18.333a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416ZM15.833 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM4.167 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.025 6.683a5.774 5.774 0 0 0 5.45 3.875H9.5l2.942-.008a2.826 2.826 0 0 1 2.741 2.075v1.542c0 .35.284.633.642.633.35 0 .633-.283.633-.633V4.8a.633.633 0 0 0-.633-.633.64.64 0 0 0-.642.633v5.517a4.117 4.117 0 0 0-2.733-1.05h-.017l-2.941.008h-.017a4.488 4.488 0 0 1-4.242-3.017.655.655 0 0 0-.608-.425.905.905 0 0 0-.208.034.641.641 0 0 0-.392.816Z"
}));
export default Hierarchy2Icon;